import React, { useState } from 'react';
import { DeviceWidth } from '../constants';

export const useViewport = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [isMobile, setIsMobile] = useState(false);

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  React.useEffect(() => {
    setIsMobile(width <= DeviceWidth.MOBILE);
  }, [width]);

  // Return width and isMobile so we can use it in our components
  return { width, isMobile };
};
